<search-container [searchColumns]="searchColumns" (searchableDataChanged)="onSearchDataChange($event)" [dataStream]="ds"></search-container>
<filter-container [filters]="filters" (filteredDataChange)="onFilteredDataChange($event)" [dataStream]="ds"></filter-container>
<base-table [config]="config" [dataStream]="data$" [pushData]="false"></base-table>
